import { APIResponseStatus } from 'Services/api.types';

import { useSaleDetailsSub } from '../../hooks/useSaleDetailsSub';
import { useVehicleCollectionSub } from '../../hooks/useVehicleCollectionSub';

import { type SaleDetailsContentViewProps, SaleDetailsContentView } from './components/SaleDetailsContentView/SaleDetailsContentView';
import { SaleDetailsContentProps } from './SaleDetails.types';

export const useSaleDetailsContent = ({
  showDetailsItems, title, titleIcon, variant,
}: SaleDetailsContentProps): SaleDetailsContentViewProps => {
  const { isSaleComplete } = useVehicleCollectionSub();

  const {
    financingAmount,
    hasNegativeEquity,
    neBankTransferTotalAmount,
    offerStatus,
    sellerAmount,
    soldForFigure,
    vehicleThumbnail,
  } = useSaleDetailsSub();

  const {
    showHomeCollectionLineItem = true,
    showPayoutDetails = false,
  } = showDetailsItems ?? {};

  return {
    bankTransferFigure: neBankTransferTotalAmount,
    financeFigure: financingAmount,
    mode: (() => {
      if (isSaleComplete) {
        return 'saleComplete';
      }

      if (hasNegativeEquity) {
        return 'negativeEquity';
      }

      return 'positiveEquity';
    })(),
    sellerFigure: sellerAmount,
    showAsError: offerStatus === APIResponseStatus.ERROR,
    showHomeCollectionLineItem,
    showOverpaymentMessage: !isSaleComplete,
    showPayoutDetails,
    showVehicleCard: Boolean(vehicleThumbnail),
    soldForFigure,
    title,
    titleIcon,
    variant,
  };
};

export const SaleDetailsContent = (props: SaleDetailsContentProps) => (
  <SaleDetailsContentView {...useSaleDetailsContent(props)} />
);
